import {css} from 'lit';
export const styles = css`:host {
  --dropdown-min-width: 200px;
  --dropdown-max-width: 350px;
  --dropdown-margin: 0;
  --dropdown-padding: 4px 0;
  --list-item-padding: 8px 8px;
  --list-item-bg: transparent;
  --list-item-bg-hover: var(--gray-100);
  --list-item-bg-active: var(--gray-200);
  --list-item-border: none;
  --list-item-color: var(--dark-text);
  --divider-border-color: var(--border-light);
  --divider-border-width: 1px;
  --divider-border-margin: 4px 0;
  --icon-min-width: 28px;
  --icon-font-size: 1.4em;

  font-size: var(--font-size-sm);
}

ef-dropdown {
  --dropdown-z-index: 900;
}

ef-dropdown > ul {
    width: -webkit-max-content;
    width: max-content;
    min-width: var(--dropdown-min-width);
    max-width: var(--dropdown-max-width);
    margin-top: var(--dropdown-margin);
    margin-bottom: var(--dropdown-margin);
    padding: var(--dropdown-padding);
    word-break: break-all;
    list-style-type: none;
  }

ef-dropdown > ul > li > * {
        display: block;
        width: 100%;
        padding: var(--list-item-padding);
        background-color: var(--list-item-bg);
        border: var(--list-item-border);
        color: var(--list-item-color);
      }

ef-dropdown > ul > li > * > ef-icon-block {
          --icon-font-size-primary: var(--icon-font-size);
          --min-width: var(--icon-min-width);
        }

ef-dropdown > ul > li > *.focus-visible {
          outline-offset: -2px;
        }

ef-dropdown > ul > li > *:focus-visible {
          outline-offset: -2px;
        }

@media (hover: hover) {
          ef-dropdown > ul > li > *:hover {
            background-color: var(--list-item-bg-hover);
          }
        }

ef-dropdown > ul > li > *:active {
          background-color: var(--list-item-bg-active);
        }

ef-dropdown > ul > li.divider {
        height: var(--divider-border-width);
        margin: var(--divider-border-margin);
        background-color: var(--divider-border-color);
      }

ef-dropdown > ul > li.text-danger {
        --text-primary: var(--danger);
      }

ef-dropdown > ul > li.active {
      --icon-color-primary: var(--secondary-500);
    }

ef-dropdown > ul > li.active.bookmark ef-icon-block {
        --icon-color-primary: var(--primary);
      }

ef-dropdown > ul > li.active.pin ef-icon-block {
        --icon-color-primary: var(--color3);
      }

ef-dropdown > ul > li.active.subscribe ef-icon-block {
        --icon-color-primary: var(--color6);
      }

ef-dropdown > ul > li.active.favorite ef-icon-block {
        --icon-color-primary: var(--color1);
      }

ef-dropdown > ul > li.active.notifications ef-icon-block {
        --icon-color-primary: var(--color4);
      }

ef-dropdown > ul > li.facebook {
      --icon-color-primary: var(--facebook-brand-color);
    }

ef-dropdown > ul > li.twitter {
      --icon-color-primary: var(--twitter-brand-color);
    }

ef-dropdown > ul > li.whatsapp {
      --icon-color-primary: var(--whatsapp-brand-color);
    }

ef-dropdown .trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    width: var(--dot-menu-trigger-width, 28px);
    max-width: 28px;
    max-width: var(--dot-menu-trigger-width, 28px);
    height: 28px;
    height: var(--dot-menu-trigger-height, 28px);
    padding: 0;
    background-color: var(--contrast-light);
    background-color: var(--dot-menu-trigger-bg, var(--contrast-light));
    border: 1px solid var(--text-secondary);
    border: var(--dot-menu-trigger-border, 1px solid var(--text-secondary));
    border-radius: 50%;
    border-radius: var(--dot-menu-trigger-radius, 50%);
    color: var(--text-secondary);
    color: var(--dot-menu-trigger-color, var(--text-secondary));
    font-size: 22px;
    font-size: var(--dot-menu-trigger-font-size, 22px);
    overflow: hidden;
    transition: all var(--transition-timing) var(--transition-duration);
    -webkit-user-select: none;
            user-select: none;
  }

@media (hover: hover) {
      ef-dropdown .trigger:hover {
        background-color: var(--gray-100);
        background-color: var(--dot-menu-trigger-bg-hover, var(--gray-100));
      }
    }

ef-dropdown .trigger:active {
      background-color: var(--gray-200);
      background-color: var(--dot-menu-trigger-bg-active, var(--gray-200));
    }
`;
export default styles;
